import { getLabel } from "./statuses";

const forms = {
    statuses: [
        { value: "open", label: getLabel("open") },
        { value: "draft", label: getLabel("draft") },
        { value: "completed", label: getLabel("completed") },
    ],
};

export default forms;